import styled from '@emotion/styled'

import type { FC } from 'react'

import Button from '@segment/matcha/components/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

interface EvaluateProps {
  heading: string
  description: string
}

const button = {
  text: `Take the quiz`,
  href: `/customer-data-maturity-evaluation/`,
}

const Evaluate: FC<EvaluateProps> = ({ heading, description }) => {
  const pageConfig = usePageConfig()

  return (
    <StyledSection variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{heading}</CopyText.Heading>
          <CopyText.Description>{description}</CopyText.Description>
          <StyledButton href={getAbsoluteUrl(button.href, pageConfig)} variant="filled" color="primary" size="large">
            {button.text}
          </StyledButton>
        </CopyTextBase>
      </Section.Copy>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;

    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-bottom: 80px;
    }
  }
`

const StyledButton = styled(Button)`
  margin-top: 20px;
`

export default Evaluate
